import axiosInstance from "../utils/axios";

export const dashboardService = {
  fetchTrendData: async (startDate, endDate) => {
    const response = await axiosInstance.get(`/dashboard-analytics/trend`, {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data;
  },
  fetchSummaryData: async () => {
    const response = await axiosInstance.get(`/dashboard-analytics/summary`);
    return response.data;
  },
  fetchRegionalData: async () => {
    const response = await axiosInstance.get(`/dashboard-analytics/regional`);
    return response.data;
  }

};